(function() {
  'use strict';

  angular
    .module('iqxCore')
    .service('toastSvc', toastSvc)

  function toastSvc($rootScope, $window) {
    var svc = this
    svc.success = success
    svc.danger = danger
    svc.error = error
    svc.info = info
    svc.clear = clear

    var successToasts = {}

    // iziToast documentation: http://izitoast.marcelodolza.com//

    function clear(x) {
      var toast = document.querySelector(`#${x}`)
      if (toast) {
        iziToast.hide({}, toast)
      }
    }

    function success(title, message) {
      iziToast.show({
        animateInside: true,
        title: title,
        message: (message || ""),
        icon: 'fas fa-check fa-fw animated slow',
        iconColor: '#fff',
        progressBar: false,
        position: 'bottomCenter',
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOutDown',
        transitionInMobile: 'fadeIn',
        transitionOutMobile: 'fadeOut',
        backgroundColor: '#5cb85c',
        titleColor: '#fff',
        titleSize: 18,
        messageColor: '#fff',
        messageSize: 16,
        timeout: 3000,
        displayMode: 2,
        onOpening: addEventListener,
        onClosing: removeEventListener
      })

      function addEventListener(instance, toast) {
        successToasts[instance.id] = $rootScope.$on('$locationChangeStart', function(event, newUrl) {
          iziToast.hide({
            transitionOut: 'fadeOutDown',
            transitionOutMobile: 'fadeOut'
          }, toast)
        })
      }

      function removeEventListener(instance) {
        successToasts[instance.id]() // remove event listener as the toast is closing its self anyway
        delete successToasts[instance.id]
      }
    }

    function danger(title, callBack) {
      iziToast.show({
        animateInside: true,
        title: title,
        message: "",
        icon: 'fas fa-check fa-fw animated slow',
        iconColor: '#fff',
        progressBar: false,
        position: 'bottomCenter',
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOutDown',
        transitionInMobile: 'fadeIn',
        transitionOutMobile: 'fadeOut',
        backgroundColor: '#d9534f',
        titleColor: '#fff',
        titleSize: 18,
        messageColor: '#fff',
        messageSize: 18,
        timeout: 20000,
        displayMode: 0,
        buttons: [
          [
            '<button class="btn">Undo</button>',
            function(instance, toast) {
              iziToast.hide({
                transitionOut: 'fadeOut'
              }, toast)
              callBack()
            }
          ]
        ]
      })
    }

    function error(title, message, id=null){
      iziToast.show({
        id:id,
        animateInside: true,
        title: title,
        class: 'errorToast',
        message: (message),
        icon: 'fas fa-times fa-fw animated slow',
        iconColor: '#fff',
        progressBar: false,
        position: 'bottomCenter',
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOutDown',
        transitionInMobile: 'fadeIn',
        transitionOutMobile: 'fadeOut',
        backgroundColor: '#a94442',
        titleColor: '#fff',
        titleSize: 18,
        messageColor: '#fff',
        messageSize: 16,
        timeout: 5000,
        displayMode: 2
      })
    }    

    function info(title, message, id=null, timeout=2000){
      iziToast.show({
        id:id,
        animateInside: true,
        title: title,
        class: 'infoToast',
        message: (message),
        icon: 'fas fa-times fa-fw animated slow',
        iconColor: '#fff',
        progressBar: false,
        position: 'bottomCenter',
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOutDown',
        transitionInMobile: 'fadeIn',
        transitionOutMobile: 'fadeOut',
        backgroundColor: '#0066a9',
        titleColor: '#fff',
        titleSize: 18,
        messageColor: '#fff',
        messageSize: 16,
        timeout: timeout,
        displayMode: 2
      })
    }

  }
})() 